const basePath = 'api/campaign';
const basePathNewVersion = '/api/listing/portal/advertise/v1';

export const SIDE_DECK_BANNER = `${basePath}/v1.1/ad/search/banner`;
export const WITHIN_POST_BANNER = `${basePath}/ad/search/banner/v1`;
export const IMPRESSION_MULTI = `${basePath}/track/impression/v0`;


export const GET_BANNER_NEW_VERSION = `${basePathNewVersion}/load`;
